import Service from '../publish-purchase-service.js';

// 保存项目信息
const savePurchaseInfo = ({}, params) => {
  return new Promise((resolve, reject) => {
    Service.savePurchaseInfo(params).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 编辑项目信息
const updatePurchaseInfo = ({}, params) => {
  return new Promise((resolve, reject) => {
    Service.updatePurchaseInfo(params).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 回显项目信息
const getPurchaseInfo = ({}, params) => {
  return new Promise((resolve, reject) => {
    Service.getPurchaseInfo(params).then(response => {
      resolve(response);
    }, error => {
      reject(error.data);
    });
  });
};

// 更改进度条标题
const updatePurchaseProcessList = ({ commit }, { projectType, purchaseType }) => {
  let purchaseProcessList = ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请'];
  let purchaseProcessList2 = ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '提交申请'];
  // 一般招标 依法招标
  if(Number(projectType) === 1 && [4, 5].includes(Number(purchaseType))) {
    // 移除 编辑采购文件
    commit('UPDATE_PURCHASE_PROCESS_LIST', purchaseProcessList2);
  } else {
    commit('UPDATE_PURCHASE_PROCESS_LIST', purchaseProcessList);
  }
};

export const actions = {
  savePurchaseInfo,
  updatePurchaseInfo,
  getPurchaseInfo,
  updatePurchaseProcessList
};
